export default {
    state: {
        registerWindows: false,
        registerType: 'signup',
        showPreLoadScreen: true
    },
    getters: {
        getRegisterWindows(state) {
            return state.registerWindows;
        },
        getRegisterType(state) {
            return state.registerType;
        },
        getShowPreLoadScreen(state) {
            return state.showPreLoadScreen;
        }
    },
    mutations: {
        setRegisterWindows(state, payload) {
            state.registerWindows = payload;
        },
        setRegisterType(state, payload) {
            state.registerType = payload;
        },
        setShowPreLoadScreen(state, payload) {
            state.showPreLoadScreen = payload;
        }
    }
};
